import CTNCalendar from '@ctn/ui/components/ctn-calendar';
import CTNInput from '@ctn/ui/components/ctn-input';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGlobalContext } from '@/context/global.context';

import { ESTADO_COLOR } from '@/constants/tramite.constants';
import { commonCalendar } from '@/helpers/calendar';
import { type FormTramiteValues } from '@/interfaces/model/don.interface';

import FieldDisplay from '../../../components/FieldDisplay';

type SolicitudSummaryProps = {
	readonly title: string;
};

const SolicitudSummary = ({ title }: SolicitudSummaryProps) => {
	const { control, watch, setValue } = useFormContext<FormTramiteValues>();
	const {
		maestrosTramite: { configuracionTramite },
	} = useGlobalContext();

	const estadoTramite = watch('estadoTramite');
	const protocolo = watch('protocolo');
	const fechaFirma = watch('fechaFirma');
	const hasFechaVencimiento = configuracionTramite?.permiteVencimiento;


	useEffect(() => {
		if (protocolo?.fechaAutorizacion) {
			setValue('fechaFirma', protocolo.fechaAutorizacion);
		}
	}, [protocolo]);

	return (
		<form>
			<div className="o-splitter">
				<h4 className="c-pnp-heading-h4">{title}</h4>
			</div>
			<div className="[ o-grid ] [ u-mt-16 ] [ u-flow ]">
				<div className="o-grid__row">
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="numeroTramite"
						label="Nº de solicitud"
						control={control}
					/>
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="tipoNNJJ.descripcion"
						label="Tipo de negocio jurídico"
						control={control}
						maxLength={32}
					/>
					<FieldDisplay
						noFeedBack
						condensed
						displayOnly
						className="o-grid__col-12 o-grid__col-4@portrait"
						name="estadoTramite.descripcion"
						label="Estado"
						iconLeft={{
							icon: 'status',
							color: ESTADO_COLOR[estadoTramite?.id as keyof typeof ESTADO_COLOR] ?? 'gray-50',
						}}
						control={control}
					/>
				</div>
				<div className="o-grid__row">
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="tipoFirmaDesc"
						label="Tipo de firma"
						control={control}
					/>
					{!fechaFirma && (
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="fechaPrevistaFirma"
							label="Fecha prevista de firma"
							control={control}
						/>
					)}
					{fechaFirma && (
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="fechaFirma"
							label="Fecha de firma"
							control={control}
						/>
					)}
					<CTNInput
						noFeedBack
						displayOnly
						condensed
						type="text"
						classNameField="o-grid__col-12 o-grid__col-4@portrait"
						name="nombreNotario"
						label="Notario"
						control={control}
					/>
				</div>
				<div className="o-grid__row">
					{hasFechaVencimiento && (
						<CTNCalendar
							{...commonCalendar}
							noFeedBack
							displayOnly
							condensed
							monthsShown={1}
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="fechaVencimiento"
							label="Vigencia"
							todayButton=""
							appendTo={undefined}
							control={control}
						/>
					)}
					{[5, 6, 7].includes(estadoTramite?.id) && (
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-8@portrait"
							name="observacionesCancelacion"
							label="Motivo de cancelación"
							control={control}
						/>
					)}
				</div>
			</div>
		</form>
	);
};

export default SolicitudSummary;
